import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../utils/axiosConfig';

// Acciones asíncronas
export const loadUser = createAsyncThunk('auth/loadUser', async (_, { rejectWithValue }) => {
    try {
        const response = await axios.get('/api/auth/user');
        if (!response.data || typeof response.data !== 'object' || Array.isArray(response.data) || !response.data.email) {
            throw new Error('Respuesta de usuario invalida');
        }
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
    }
});

export const logout = createAsyncThunk('auth/logout', async (_, { rejectWithValue }) => {
    try {
      await axios.post('/api/auth/logout');  // 👈 POST 204, sin redirect
      return true;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  });

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        isAuthenticated: false,
        user: null,
        loading: true,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(loadUser.pending, (state) => {
                console.log('🔄 Cargando usuario...');
                state.loading = true; // Indicamos que está cargando
            })
            .addCase(loadUser.fulfilled, (state, action) => {
                console.log('✅ Usuario cargado:', action.payload);
                state.isAuthenticated = true;
                state.user = action.payload;
                state.loading = false; // La carga ha terminado
                state.error = null;
            })
            .addCase(loadUser.rejected, (state, action) => {
                console.log('❌ Error al cargar usuario:', action.payload);
                state.isAuthenticated = false;
                state.user = null;
                state.loading = false; // También termina la carga en caso de error
                state.error = action.payload;
            })
            .addCase(logout.fulfilled, (state) => {
                state.isAuthenticated = false;
                state.user = null;
                state.loading = false;
            });
    },
});

export default authSlice.reducer;
